export default "__VITE_ASSET__BbmIkJQS__"